import {
  PlanEventInformation,
  PlanMeasureKey,
} from "features/CenterContent/RoleContent/EventHandling/components/EventChangesDialog/types";
import InfraEventCard from "features/CenterContent/RoleContent/EventHandling/components/InfraEventCard/InfraEventCard";
import TrainEventCard from "features/CenterContent/RoleContent/EventHandling/components/TrainEventCard";
import {
  eventIsInfrastructureEvent,
  eventIsTrainEvent,
} from "features/History/utils/utils";
import { FC, useMemo } from "react";
import { Flex, tokens, VStack } from "shared/components/Spor";
import { useTheme } from "styled-components";

type EventStateColumnProps = {
  measures: PlanEventInformation[];
  columnEventState: PlanMeasureKey;
  showClosed?: boolean;
};

export const EventStateColumn: FC<EventStateColumnProps> = ({
  measures,
  columnEventState,
  showClosed = true,
}) => {
  const events = measures
    .map(({ information }) => information)
    .filter((i) => showClosed || i.state !== "CLOSED");
  const theme = useTheme();

  // Sort events by createdAt date, Newest first
  const sortedEvents = useMemo(
    () =>
      events.toSorted((a, b) => {
        const dateA =
          "createdAt" in a && a.createdAt ? new Date(a.createdAt) : new Date(0);
        const dateB =
          "createdAt" in b && b.createdAt ? new Date(b.createdAt) : new Date(0);
        return dateB.getTime() - dateA.getTime();
      }),
    [events],
  );

  return (
    <Flex
      backgroundColor={theme.colorBackgroundSecondary}
      borderRadius={tokens.default.size.spacing[1]}
      flexDirection="column"
      width="100%"
      p={tokens.default.size.spacing[1]}
      overflowY="auto"
    >
      <VStack gap={tokens.default.size.spacing[1]}>
        {sortedEvents.length !== 0
          ? sortedEvents.map((event) => {
              const key = `${event.uuid}-${event.version}`;
              if (eventIsInfrastructureEvent(event)) {
                return (
                  <InfraEventCard
                    key={key}
                    event={event}
                    columnEventState={columnEventState}
                  />
                );
              }
              if (eventIsTrainEvent(event)) {
                return (
                  <TrainEventCard
                    key={key}
                    event={event}
                    columnEventState={columnEventState}
                  />
                );
              }
              return null;
            })
          : null}
      </VStack>
    </Flex>
  );
};
